import React, { useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge,
  CFormText,
} from "@coreui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { insert, update, remove } from "src/services/Users";
import CIcon from "@coreui/icons-react";
import { cilTrash } from "@coreui/icons";
import { Toaster } from "src/components/Toaster";
import ls from "local-storage";
import Select from "react-select";
var md5 = require("md5");

function UsersActions() {
  const [id, setID] = useState(0);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState({
    label: "Tidak",
    value: "0",
  });
  const [typeOptions, setTypeOptions] = useState([
    {
      label: "Tidak",
      value: "0",
    },
    {
      label: "Ya",
      value: "1",
    },
  ]);
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("");
  const [password, setPassword] = useState("");
  useEffect(() => {
    if (location.state) {
      setIsEdit(true);
      setID(location.state.id);
      setName(location?.state?.name ?? "");
      setType({
        label: location?.state?.backofficeAccess ?? "",
        value: location?.state?.rawBackofficeAccess ?? "",
      });
      setPhone(location?.state?.phone ?? "");
      setEmail(location?.state?.email ?? "");
    }
  }, [location]);

  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor("red");
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        name: name,
        type: type.value,
        phone: phone,
        email: email,
        password: password ? md5(password) : "",
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor("red");
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get("errorMessage"));
            setOpen(true);
            setColor("red");
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }
  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? "red"} />
      <CCardHeader>Actions - Users</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: "16px" }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Nama</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>

          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>HP</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Email</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Password</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                feedbackInvalid="Required value"
                required={location.state ? false : true}
              />
              {location.state ? (
                <CFormText>Isi password jika ingin mengganti password. kosongkan jika tidak</CFormText>
              ) : (
                ""
              )}
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Akses Backoffice</CFormLabel>&nbsp; <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <Select
                placeholder="Pilih Type"
                value={type}
                options={typeOptions}
                onChange={(e) => {
                  setType(e);
                }}
                isDisabled={false}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
        </div>
        <CCardFooter style={{ textAlign: "right" }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: "black",
              backgroundColor: "white",
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: "white",
            }}
            type="submit"
          >
            Save
          </CButton>
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default UsersActions;
